module.exports = __webpack_public_path__ + "static/img/ikonaMikrofon-ON.731c2a62.png";